import "./Header.css";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import fotoDrBruno1 from "../../assets/img/fotoDrBruno1.png";

function Header() {
  const navigate = useNavigate();

  const goToSection = (id) => {
    navigate("/", { state: { scrollTo: id } });
  };

  return (
    <header className="header-banner scroll-reveal-opacity">
      <div className="container">
        <div className="row align-items-center">

          {/* TEXTO */}
          <div className="col-12 col-lg-6  scroll-reveal-opacity">
            <h1 className="header-title">
              UROLOGIA GERAL <br />E RECONSTRUTORA
            </h1>

            <p className="header-subtitle">
              Tecnologia, experiência e precisão para devolver sua liberdade,
              autonomia e autoestima com resultados consistentes e seguros.
            </p>

            <div className="lista-beneficios">
              <div className="item">
                <span className="icone">✔</span>
                <p>Atendimento especializado em casos complexos</p>
              </div>

              <div className="item">
                <span className="icone">✔</span>
                <p>Foco em qualidade de vida e autonomia</p>
              </div>

              <div className="item">
                <span className="icone">✔</span>
                <p>Acompanhamento próximo e individualizado</p>
              </div>
            </div>

            <a
  target="_blank"
  rel="noopener noreferrer"
  href="https://wa.me/5521983132240?text=Vim%20pelo%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20os%20as%20consultas."
  className="btn-agendar"
  onClick={() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "whatsapp_click",
      origem: "header",
      tipo: "botao_principal",
      pagina: window.location.pathname
    });
  }}
>
  Agendar Minha Consulta
</a>
          </div>

          {/* IMAGEM */}
          <div className="col-12 col-lg-6 text-center scroll-reveal-opacity">
            <div className="img-wrapper">
              <img
                src={fotoDrBruno1}
                alt="Foto Dr. Bruno Corrêa"
                className="img-fluid"
              />
            </div>
          </div>

        </div>
      </div>
    </header>
  );
}

export default Header;